/** Prefixo do app em produção. Vazio na raiz do domínio; `/vendas` em subpasta. */
export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH || "";

/** Path do cookie: `/` na raiz, `/vendas` em subpasta. */
export const COOKIE_PATH = BASE_PATH || "/";

/** Monta URL absoluta do front (assets, window.location, âncoras). */
export function withBasePath(path: string): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${BASE_PATH}${normalized}`;
}
